import { Component, inject, ViewEncapsulation } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';

import { TiiaService } from '@kp/tiia-services';

@Component({
  selector: 'kp-loading',
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class LoadingComponent {
  readonly showLoader = toSignal(
    inject(TiiaService).showLoading$.pipe(
      // I want to show Načítám label just if loading is true otherwise show custom label
      map(loading => (loading === true ? 'Načítám...' : loading)),
    ),
  );
}
